<!--
 * @Author: ZS
 * @Date: 2020-06-23 15:18:35
 * @LastEditors: ZS
 * @LastEditTime: 2020-07-17 17:58:45
 * @Description: file content
-->
<!--
 * @Author: ZS
 * @Date: 2020-06-18 16:24:41
 * @LastEditors: ZS
 * @LastEditTime: 2020-06-23 10:15:37
 * @Description: file content
-->
<template>
  <div class="myBusiness">
    <div class="search_wrap">
      <template v-for="(item, index) in searchList">
        <div
          class="search_item"
          :key="index"
        >
          <span class="left">{{item.label}}</span>
          <span class="right">
            <template v-if="item.field === 'text'">
              <el-input
                v-model="searchData[item.code]"
                placeholder="请输入内容"
                size="medium"
                clearable
                v-blurTrim
              ></el-input>
            </template>
            <template v-if="item.field === 'select'">
              <el-select
                v-model="searchData[item.code]"
                placeholder="请选择"
                size="medium"
                clearable
              >
                <el-option
                  v-for="(vo, i) in item.options"
                  :key="`${index}_${i}`"
                  :label="vo.label"
                  :value="vo.value"
                ></el-option>
              </el-select>
            </template>
            <template v-if="item.field === 'date-range'">
              <el-date-picker
                v-model="searchData[item.code[0]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
              <span class="connection">至</span>
              <el-date-picker
                v-model="searchData[item.code[1]]"
                placeholder="请选择"
                value-format="yyyy-MM-dd"
                clearable
                size="medium"
                style="width: 140px;"
              ></el-date-picker>
            </template>
          </span>
        </div>
      </template>
      <div class="search_item btn_item">
        <el-button
          type="primary"
          size="medium"
          @click="searchFunc"
          class="search_btn"
        >搜索</el-button>
        <el-button
          size="medium"
          @click="resetFunc"
        >重置</el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="xuhao"
        width="60"
        label="序号"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="事项名称"
        prop="guidelineName"
      >
      </el-table-column>
      <el-table-column
        prop="pcHandlingGuidelineSuggestionSuggestion"
        label="评价内容"
        align="center"
      >
      </el-table-column>
      <el-table-column
        prop="pcHandlingGuidelineSuggestionSatisfaction"
        label="评价星级"
        width="180"
        align="center"
      >
        <template slot-scope="scope">
          <el-rate
            v-model="scope.row.pcHandlingGuidelineSuggestionSatisfaction"
            disabled
          >
          </el-rate>
        </template>
      </el-table-column>
      <el-table-column
        prop="pcHandlingGuidelineSuggestionTime"
        label="评价时间"
        width="160"
        align="center"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="130"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)"
            class="detailBtn"
            v-if="type === 1||type===2"
          >查看
          </el-button>
          <el-button
            size="mini"
            type="danger"
            @click="inquiryOpen(scope.$index, scope.row)"
            class="advisoryBtn"
            v-if="type === 0"
          >
            审核</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="block fenyeBox"
      v-if="totalSize > 0"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize"
      >
      </el-pagination>
    </div>
    <!-- 详情对话框 -->
    <el-dialog
      title="评价详情"
      :visible.sync="dialogVisible"
      width="550px"
      class="dialog"
    >
      <div
        style="padding:0 15px;font-size:16px"
        class="dialog"
      >
        <h4 class="tit">评价信息</h4>
        <p><span>评价分数：</span>
          <el-rate
            v-model="pjScore"
            disabled
            show-text
            :texts="texts"
            style="display:inline-block"
          >
          </el-rate>
        </p>
        <p><span>评价内容：</span>{{pjContent}}</p>
        <p><span>评价人：</span>{{pjPerson}}</p>
        <p><span>评价时间：</span>{{pjTime}}</p>
        <div v-if="type != 0">
          <h4 class="tit">审核信息</h4>
          <ul class="shxx">
            <li><i>审核状态：</i><span
                style="color:#008000"
                v-if="type===1"
              >已通过</span><span
                style="color:#FF0000"
                v-if="type===2"
              >未通过</span>
            </li>
            <li><i>审核人：</i>{{shr}}</li>
            <li><i>审核意见：</i>{{shyj}}</li>
            <li><i>审核时间：</i>{{shsj}}</li>
          </ul>
        </div>
        <div v-if="type === 0">
          <h4 class="tit">审核意见</h4>
          <el-input
            type="textarea"
            placeholder="未通过的评价填写审核意见"
            v-model="shContent"
            style="margin-bottom: 20px; min-height:60px"
          >
          </el-input>
        </div>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <template v-if=" titIndex == 0">
          <el-button
            @click="sh(1)"
            class="tjBtn"
          >通过</el-button>
          <el-button
            type="warning"
            @click="sh(2)"
          >未通过</el-button>
        </template>
        <el-button @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import qs from "qs";
export default {
  props: {
    flag: {
      type: Number,
      default: 5
    }
  },
  data() {
    return {
      tableData: [],
      value: 4.7,

      currentPage: 1,
      pageSize: 10,
      totalSize: 0,

      dialogVisible: false,
      titIndex: 0,
      pjContent: "",
      pjTime: "",
      pjPerson: "",
      pjScore: 0,
      type: 0,
      shr: "",
      shyj: "",
      shsj: "",
      shContent: "",
      id: "",
      newMsg: 0,
      texts: ["非常不满", "不满", "一般", "满意", "非常满意"],
      // 查询条件
      searchData: {},
      oldSearchData: {}
    };
  },
  computed: {
    searchList() {
      return [
        { label: "事项名称", code: "guidelineName", field: "text" },
        {
          label: "评价星级",
          code: "satisfaction",
          field: "select",
          options: [
            { label: "全部", value: "" },
            { label: "非常满意", value: "5" },
            { label: "满意", value: "4" },
            { label: "一般", value: "3" },
            { label: "不满", value: "2" },
            { label: "非常不满", value: "1" }
          ]
        },
        {
          label: "评价时间",
          field: "date-range",
          code: ["startTime", "endTime"]
        }
      ];
    },
    initSearchData() {
      return {
        guidelineName: "",
        satisfaction: "",
        startTime: "",
        endTime: ""
      };
    }
  },
  watch: {
    flag(val) {
      if (val === 7) {
        this.type = 0;
        this.titIndex = 0;
      } else if (val === 8) {
        this.type = 1;
        this.titIndex = 1;
      } else if (val === 9) {
        this.type = 2;
        this.titIndex = 2;
      }
      this.searchData = {
        ...this.initSearchData
      };
      this.oldSearchData = {
        ...this.initSearchData
      };
      this.handleCurrentChange(1);
    }
  },
  mounted() {
    this.searchData = {
      ...this.initSearchData
    };
    this.oldSearchData = {
      ...this.initSearchData
    };
    this.getPj();
  },
  methods: {
    /**
     * @name searchFunc
     * @description 查询方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:51:21
     */
    searchFunc() {
      const { startTime, endTime } = this.searchData;
      if (startTime && endTime && new Date(startTime) > new Date(endTime)) {
        // 如果两个时间都选择，且起始时间大于结束时间
        this.$message({
          type: "warning",
          message: "起始时间不能早于结束时间"
        });
        return;
      }
      this.oldSearchData = {
        ...this.searchData
      };
      this.handleCurrentChange(1);
    },
    /**
     * @name resetFunc
     * @description 重置方法
     * @param {}
     * @return {}
     * @author cjs1992
     * @date 2020-09-02 14:52:54
     */
    resetFunc() {
      this.searchData = {
        ...this.initSearchData
      };
      this.searchFunc();
    },
    handleEdit(index, row) {
      (this.pjContent = row.pcHandlingGuidelineSuggestionSuggestion),
        (this.pjTime = row.pcHandlingGuidelineSuggestionTime),
        (this.pjPerson = row.pjr),
        (this.pjScore = row.pcHandlingGuidelineSuggestionSatisfaction),
        (this.shr = row.shr);
      if (this.type === 1 || this.type === 2) {
        // this.shsj = this.publicJs.renderTime(
        //   row.portalPcGuidelineSuggestionApproval
        //     .pcGuidelineSuggestionApprovalTime
        // );
        this.shsj = row.portalPcGuidelineSuggestionApproval
            .pcGuidelineSuggestionApprovalTime;
        this.shyj =
          row.portalPcGuidelineSuggestionApproval.pcGuidelineSuggestionApprovalStatement;
      }
      this.dialogVisible = true;
    },
    inquiryOpen(index, row) {
      this.shContent = "";
      this.id = row.pcHandlingGuidelineSuggestionId;
      (this.pjContent = row.pcHandlingGuidelineSuggestionSuggestion),
        (this.pjTime = row.pcHandlingGuidelineSuggestionTime),
        (this.pjPerson = row.pjr),
        (this.pjScore = row.pcHandlingGuidelineSuggestionSatisfaction),
        (this.shr = row.shr);
      this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPj();
    },
    getPj() {
      let sendData;
      sendData = qs.stringify({
        type: this.type,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        memberId: this.$store.state.userId,
        ...this.oldSearchData
      });
      this.ywtbRequest(
        "/portal-ywtb/web/guidelineSuggestion/listSuggestionByCondition",
        sendData
      ).then((res) => {
        var data = res.dataList;
        this.totalSize = res.count;
        if (this.type === 0) {
          this.$emit("newMsg", res.count);
        }
        for (let i = 0; i < data.length; i++) {
          data[i].xuhao = i + 1 + this.pageSize * (this.currentPage - 1);
          // data[i].pcHandlingGuidelineSuggestionTime = this.publicJs.renderTime(
          //   data[i].pcHandlingGuidelineSuggestionTime
          // );
        }
        this.tableData = data;
      });
    },
    sh(state) {
      let sendData = qs.stringify({
        pcGuidelineSuggestionApprovalSuggestionId: this.id,
        pcGuidelineSuggestionApprovalStatement: this.shContent,
        pcGuidelineSuggestionApprovalApprover: this.$store.state.userId,
        pcHandlingGuidelineSuggestionState: state
      });
      if (
        (!this.shContent || String(this.shContent).trim() === "") &&
        state === 2
      ) {
        this.$message({
          message: "请输入审核意见",
          type: "warning"
        });
        return;
      }
      this.ywtbRequest(
        "/portal-ywtb/web/guidelineSuggestion/saveSuggestionByCondition",
        sendData
      ).then((res) => {
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.dialogVisible = false;
        this.getPj();
      });
    }
  }
};
</script>

<style scoped>
.myTit {
  /* line-height: 42px; */
  padding: 30px 0 15px 0;
  font-size: 16px;
  margin-bottom: 10px;
}

.myTit > span {
  float: left;
  color: #091b28;
  font-size: 22px;
  font-family: PingFang SC;
}

.myTit > ul {
  float: right;
}

.myTit > ul > li {
  float: left;
  width: 84px;
  height: 34px;
  background: rgba(53, 139, 247, 0.1);
  color: #687986;
  line-height: 34px;
  font-size: 16px;
  font-weight: normal;
  text-align: center;
  cursor: pointer;
}

.myTit > ul > li.active {
  background-color: #358bf7;
  color: #fff;
}

.detailBtn,
.advisoryBtn {
  width: 56px;
  height: 27px;
  border-radius: 14px;
  padding: 0;
  text-align: center;
  font-size: 13px;
  color: #fff;
  border: none;
}

.detailBtn {
  background: rgba(255, 165, 71, 1);
}

.detailBtn:hover,
.detailBtn:focus {
  background: rgba(255, 165, 71, 0.8);
  color: #fff;
}

.advisoryBtn {
  background: rgba(53, 139, 247, 1);
}

.advisoryBtn:hover,
.advisoryBtn:focus {
  background: rgba(53, 139, 247, 0.8);
  color: #fff;
}

.fenyeBox {
  text-align: center;
  padding-top: 20px;
}

.newBg {
  display: inline-block;
  width: 55px;
  height: 23px;
  line-height: 22px;
  background: url(../../../static/images/newBg.png) no-repeat 0px 0px;
  text-align: center;
  color: #fff;
  margin-left: 6px;
}

.dialog p {
  line-height: 36px;
}

.dialog /deep/ .el-rate__icon {
  font-size: 24px;
}

.shxx li {
  line-height: 36px;
  font-size: 14px;
}
.shxx li > i {
  display: inline-block;
  width: 70px;
  text-align: right;
  color: #999;
  color: #8c8c8c;
}
.dialog p {
  line-height: 36px;
  font-size: 14px;
}
.dialog p > span {
  display: inline-block;
  width: 70px;
  text-align: right;
  color: #8c8c8c;
}
.dialog /deep/ .el-rate__icon {
  font-size: 24px;
}

.dialog /deep/ .el-dialog__title {
  color: #262626;
  font-size: 18px;
  font-weight: 700;
}

.dialog /deep/ .el-textarea__inner {
  resize: none;
}

.dialog /deep/ .el-dialog__body {
  padding: 25px 40px 5px 30px;
}

.dialog /deep/ .el-dialog__footer {
  text-align: center;
  padding: 15px 0 30px 0;
}

.dialog /deep/ .el-button {
  border-radius: 2px;
}

.dialog .tjBtn {
  background: rgba(68, 110, 255, 1);
  color: #fff;
  border: none;
}

.dialog .tjBtn:hover {
  background: rgb(50, 93, 250);
}
h4.tit {
  color: #262626;
  font-size: 16px;
  font-weight: 700;
  padding-left: 10px;
  border-left: 4px solid #446eff;
  margin: 15px 0;
}
</style>
<style lang="scss" scoped>
@import "./common.scss";
</style>



// WEBPACK FOOTER //
// src/components/workbench/EvaluationReview.vue